import { Injectable } from '@angular/core';

import { StatsigService } from '@services/statsig.service';

export enum COACHING_FEATURE_FLAGS {
  COMPLIANCE_COACHING_ENABLED = 'compliance-coaching-enabled',
  COMPLIANCE_COACHING_SETTINGS_REVERT_ENABLED = 'compliance-coaching-settings-revert-enabled',
  SAFETY_COACHABLE_SINCE_HIGHER_THRESHOLD_ENABLED = 'safety-coachable-since-higher-threshold-enabled',
  SAFETY_MOTIVE_COACH_ENABLED = 'safety-motive-coach-enabled',
  SAFETY_MOTIVE_COACH_PHASE2_ENABLED = 'safety-motive-coach-rule-2-enabled',
  AUTO_MESSAGE_DRIVERS_ONCE_COACHED = 'ent-auto-share-coaching-summary-enabled',
  COACHING_PERMISSIONS_BY_ROLE_ENABLED = 'coaching-permissions-by-role-enabled',
}

@Injectable({ providedIn: 'root' })
export class CoachingFeatureFlagService {
  constructor(
    private statsigService: StatsigService,
  ) {}

  public isComplianceCoachingEnabled(): boolean {
    return this.statsigService.evaluateGate(COACHING_FEATURE_FLAGS.COMPLIANCE_COACHING_ENABLED);
  }

  public isSafetyCoachableSinceHigherThresholdEnabled(): boolean {
    return this.statsigService.evaluateGate(COACHING_FEATURE_FLAGS.SAFETY_COACHABLE_SINCE_HIGHER_THRESHOLD_ENABLED);
  }

  public isComplianceCoachingSettingsRevertEnabled(): boolean {
    return this.statsigService.evaluateGate(COACHING_FEATURE_FLAGS.COMPLIANCE_COACHING_SETTINGS_REVERT_ENABLED);
  }

  public isSafetyMotiveCoachEnabled(): boolean {
    return this.statsigService.evaluateGate(COACHING_FEATURE_FLAGS.SAFETY_MOTIVE_COACH_ENABLED);
  }

  public isSafetyMotiveCoachPhase2Enabled(): boolean {
    return this.isSafetyMotiveCoachEnabled() &&
      this.statsigService.evaluateGate(COACHING_FEATURE_FLAGS.SAFETY_MOTIVE_COACH_PHASE2_ENABLED);
  }

  public isAutoMessageDriversOnceCoachedEnabled(): boolean {
    return this.statsigService.evaluateGate(COACHING_FEATURE_FLAGS.AUTO_MESSAGE_DRIVERS_ONCE_COACHED);
  }

  public isCoachingPermissionsByRoleEnabled(): boolean {
    return this.statsigService.evaluateGate(COACHING_FEATURE_FLAGS.COACHING_PERMISSIONS_BY_ROLE_ENABLED);
  }
}
